import { InjectionToken } from '@angular/core';
import type { EventEmitter } from '@angular/core';
import type { ComponentType } from '@angular/cdk/overlay';

export interface HelpArticleResolver {
  getHelpArticleId(): string;
}

export interface HelpLinkData {
  articleId: string;
}

export interface IHelpComponent extends HelpLinkData {
  closeEvent: EventEmitter<void>;
}

export const HELP_LINK_COMPONENT_TYPE = new InjectionToken<ComponentType<IHelpComponent>>('helpLinkComponentType');

export const HELP_LINK_ARTICLE_RESOLVER = new InjectionToken<HelpArticleResolver>('helpLinkArticleResolver');
